import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
  MDBTable,
} from "mdb-react-ui-kit";
import React from "react";

const InvoicePage = () => (
  <MDBContainer className="py-4">
    <section>
      <MDBCard className="mb-4">
        <MDBCardBody className="py-3">
          <MDBRow>
            <MDBCol sm="6" className="text-center text-sm-start">
              <h5 className="mb-3 mb-sm-0 mt-1">Invoice #203</h5>
            </MDBCol>

            <MDBCol sm="6" className="text-center text-sm-end">
              {/* <MDBBtn type="button" color="danger" className="me-2">
                Pay now
              </MDBBtn>
              <MDBBtn type="button">
                <MDBIcon fas icon="print" className="me-1" />
                Print
              </MDBBtn> */}
            </MDBCol>
          </MDBRow>
        </MDBCardBody>
      </MDBCard>

      <MDBCard className="mb-4">
        <MDBCardBody>
          <MDBRow>
            <MDBCol md="6" className="mb-4 mb-md-0 text-center text-md-start">
              <p>
                <small>From:</small>
              </p>
              <p>
                <strong>Chalicham Technologies Inc</strong>
              </p>
              <p>5090 Olive Ln N</p>
              <p>Plymouth</p>
              <p>MN 55446</p>
              <p>
                <strong>Invoice date:</strong> Jul 24, 2024
              </p>
              <p>
                <strong>Due date:</strong>  Aug 5, 2024
              </p> 
            </MDBCol>

            <MDBCol md="6" className="text-center text-md-end">
              <h5>
                <small>Invoice No.</small>
                <br />
                <strong>
                  <span className="text-primary">#203</span>
                </strong>
              </h5>

              <p>
                <small>To:</small>
              </p>
              <p>
                <strong>Srisai Elm LLC. dba Veg Vihaar</strong>
              </p>
              <p>13974, Stevens Point Drive</p>
              <p>Frisco, Texas 75033</p>
            </MDBCol>
          </MDBRow>
        </MDBCardBody>
      </MDBCard>

      <MDBCard>
        <MDBCardBody>
          <div className="table-responsive mb-4">
            <MDBTable>
              <thead>
                <tr>
                  <th>Item list</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Tax</th>
                  <th>Total price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ERP Software</td>
                  <td>1</td>
                  <td>$20,000</td>
                  <td>$1650</td>
                  <td>$21650</td>
                </tr>
                <tr>
                  <td>Implementation and Support</td>
                  <td>1</td>
                  <td>$5,000</td>
                  <td>$412.50</td>
                  <td>$5,412.50</td>
                </tr>
               
              </tbody>
            </MDBTable>
          </div>

          <ul className="list-unstyled text-end">
            <li>
              <strong>Sub Total:</strong>
              <span className="float-end ms-3">$25000</span>
            </li>
            <li>
              <strong>TAX:</strong>
              <span className="float-end ms-3">$2062.50</span>
            </li>
            <li>
              <strong>TOTAL:</strong>
              <span className="float-end ms-3">$27062.50</span>
            </li>
          </ul>
        </MDBCardBody>
      </MDBCard>
    </section>
  </MDBContainer>
);

export default InvoicePage;
